import { ChevronDownIcon } from "@heroicons/react/24/solid";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useState } from "react";

import { mapOrientedToName } from "@/data/constants/oriented";
import { useLang } from "@/hooks/use-lang";

import { OrientedPopper } from "./OrientedPopper";

export const SymbolHeader = ({
  orientedIndex,
  setOrientedIndex,
}: {
  orientedIndex: 0 | 1 | 2 | 3 | 4;
  setOrientedIndex: (index: 0 | 1 | 2 | 3 | 4) => void;
}) => {
  const { t } = useLang();
  const orientedList = Object.values(mapOrientedToName({ t }));
  const orientedName = orientedList[orientedIndex]; // e.g. "Value" or "價值"
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  const selectOrientedIndex = (index: 0 | 1 | 2 | 3 | 4) => {
    setOrientedIndex(index);
    setIsPopperOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setIsPopperOpen(false)}>
      <div className="flex justify-between gap-3 bg-zinc-100 px-8 py-2 text-xs text-zinc-500">
        <p className="select-none text-center text-xs">
          {t.layout.watchlist.symbol}
        </p>
        <div
          className="relative flex cursor-pointer items-center justify-center"
          onMouseEnter={() => setIsPopperOpen(true)}
          onMouseLeave={() => setIsPopperOpen(false)}
        >
          <p
            className="select-none whitespace-nowrap text-xs"
            aria-label="select oriented"
          >
            {orientedName}
          </p>
          <ChevronDownIcon className="ml-2 h-3 w-3 fill-zinc-500" />
          {isPopperOpen && (
            <OrientedPopper
              currentIndex={orientedIndex}
              selectOrientedIndex={(index) =>
                selectOrientedIndex(index as 0 | 1 | 2 | 3 | 4)
              }
              orientedList={orientedList}
            />
          )}
        </div>
      </div>
    </ClickAwayListener>
  );
};
